export default {
	'en-CA': {
		'title': 'Lane Closures',
		'currency': {
			'style': 'currency',
			'currency': 'CAD'
		},
		'locale': 'Language',
		'switchToLocale': 'FranÃ§ais',
		'errors': {
			'errorsOccurred': 'The following error(s) occurred.',
			'invalidPostalCode': 'Invalid/Incomplete postal code.',
			'required': 'Required Field',
		},
		'labels': {
			'warning': 'Warning',
			'save': 'Save',
			'cancel': 'Cancel',
			'leaveAnyway': 'Leave Page',
			'stay': 'Stay on Page',
			'add': 'Add',
			'reportEmergencyClosure': 'Create Emergency Request and Report',
			'reportEmergencyRestriction': 'Create Emergency Request and Report',
		},
		'titles': {
			'forms': {},
			'lcrUpdated': 'Lane Closure Request Changed'
		},

		'messages': {
			'unsavedChanges': 'You have unsaved changes. If you leave this page, your changes will NOT be saved.',
			'lcrUpdated': 'The Lane Closure Request has been Updated. Click OK to reload the request.',
			'enterTurningRestrictionStreetName': '',
			'removeAllBlocks':'Please confirm that you want to remove all blocks from this lane closure request.  You will need to tap at least one street block on the map to submit this lane closure request.'
		},
		'filter': {
			'laneClosureRequest': 'Requests',
			'laneClosureRequest.pending': 'Pending',
			'laneClosureRequest.approved': 'Approved',
			'laneClosureRequest.denied': 'Denied',
			'laneClosureRequest.completed': 'Completed',
			'laneClosure': 'Closures',
			'laneClosure.planned': 'Planned',
			'laneClosure.active': 'Active',
			'laneClosure.expired': 'Expired',
			'restriction': 'Restrictions',
			'restriction.planned': 'Planned',
			'restriction.active': 'Active',
			'restriction.expired': 'Expired'
		},
		'header': {
			'appTitle': 'Lane Closures'
		},
		'slideUpMenu': {
			'requests': {
				'all': 'List All Requests',
				'title': 'Lane Closure Requests',
				'newRequest': 'New Lane Closure Request',
				'denied': 'Denied',
				'approved': 'Approved',
				'pending': 'Pending'
			},
			'report': {
				'reportClosure': 'Lanes Opened or Closed',
				'reportRestriction': 'Turn Restrictions In-place or Removed',
				'reportViolation': 'New Violation',
			},
			'closures': {
				'all': 'List All Closures',
				'title': 'Close / Re-open Lanes',
				'newEmergency': 'Create New Emergency Closure',
				'expired': 'Expired',
				'active': 'Active',
				'planned': 'Planned'
			},
			'restrictions': {
				'all': 'List All Restrictions',
				'title': 'Place / Remove Restrictions',
				'newEmergency': 'Create New Emergency Restriction',
				'expired': 'Expired',
				'active': 'Active',
				'planned': 'Planned'
			},
			'contraventions': {
				'all': 'List All Requests',
				'title': 'Requests',
				'without': 'Without Violations',
				'with': 'Having Violations',
				'expired': 'Expired Requests',
				'newRequestWithViolation': 'New Request with Violation'
			},
			'viewRequest': {
				'requestAttachments': 'Attachments',
				'requestActivity': 'Activity',
				'requestAuditLog': 'Audit Log',
				'requestViolations': 'Violations',
				'details': 'Details',
				'contacts': 'Contacts',
			},
			'actionRequest': {
				'reportViolation': 'Report Violation',
				'duplicate': 'Duplicate Request',
				'cancel': 'Cancel Request',
				'edit': 'Edit',
				'complete': 'Mark Request as Completed',
				'viewRequestedChanges':'View Requested Changes'
			},
			'viewRequestedChanges': {
				'requestAttachments': 'Attachments',
				'requestActivity': 'Activity',
				'requestAuditLog': 'Audit Log',
				'requestViolations': 'Violations',
				'details': 'Details',
				'backToDetails':'Back to Approved Details',
				'contacts': 'Contacts',
			},
			'actionRequestedChanges': {
				'discard': 'Discard Requested Changes',
				'editChanges': 'Edit Requested Changes',
				'details': 'Edit Requested Changes'
			},
		},
		'views': {
			'login': {
				'title': '',
				'disclaimerTitle': 'Disclaimer and Indemnity:',
				'disclaimerBody': 'The information on this web site is provided as a public service and should be used for general information purposes only. Although the information provided represents the planned capital work on city infrastructure for the current year, the City of Winnipeg cannot guarantee that it is accurate or current at all times. Although it is rare that projects are not finished within the stated timeframe, the City cannot guarantee that the work will be completed in all cases.<br/><br/>The information on this web site is subject to change without notice. Winnipeg.ca AND ITS AFFILIATES ARE NOT RESPONSIBLE IN ANY MANNER FOR DIRECT, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES HOWSOEVER CAUSED RESULTING FROM THE USE, MISUSE OR MISINTERPRETATION OF ANY CONTENT, PRODUCTS OR SERVICES PROVIDED BY THIS WEB SITE.<br/><br/>By using this site, you agree to indemnify, defend and hold harmless City of Winnipeg and its officials, officers, employees and authorized representatives from and against any liability, loss injury (including injuries resulting in death), demand, action, cost, expense, or claim of any kind, including but not limited to lawyer\'s fees, relating in any way to your use of the contents, or services provided by this web site.',
				'alreadyLoggedIn': 'You are already logged in.'
			}
		},
		'userSettings': {
			'lc-not-opened': 'WARNING: Lane closure was not reported re-opened at the estimated completion time.',
			'r-not-removed': 'WARNING: Turning restriction was not reported removed at the estimated completion time.',
			'lc-reminder-open': 'Reminder to re-open lanes at completion time.',
			'r-reminder-place': 'Reminder to place turning restrictions at start time.',
			'lc-reminder-close': 'Reminder to close lanes at start time.',
			'r-reminder-remove': 'Reminder to remove turning restrictions at completion time.',
			'lcr-status-updated': 'Approval/Record Status Change',
			'lcr-contact-added': 'You were added to the request.',
			'lcr-contact-removed': 'You were removed from the request.',
			'lcr-updated': 'Lane closure request details were changed.',
			'lcr-attachment': 'Attachment added to Lane closure request.',
			'r-not-placed': 'WARNING: Turning restriction not reported in-place at start time.',
			'contravention-new-message': 'New message for existing violation.',
			'lcr-new-message': 'New Messages',
			'contravention-updated': 'Violation was updated.',
			'lc-not-closed': 'WARNING: Lane closure not reported closed at the start time.',
			'lc-closed': 'Lanes reported as CLOSED.',
			'lc-opened': 'Lanes reported as OPENED.',
			'new-lcr': 'Confirmation that a new PENDING lane closure request was made.',
			'r-placed': 'Restrictions reported as IN PLACE.',
			'r-removed': 'Restrictions reported as REMOVED.',
			'lcr-approved': 'Request was APPROVED, you can begin work.',
			'lcr-denied': 'Request was DENIED.',
			'lcr-completed': 'Request was COMPLETED.',
			'lcr-cancelled': 'Request was CANCELLED.',
			'new-contravention': 'New Violations.',
			'lcr-change-request': 'When the requester asks for new changes to the lane closure request.',
		},

		'userSettingsAll': {
			'lc-not-opened': 'WARNING: Lane closure was not reported re-opened at the estimated completion time.',
			'r-not-removed': 'WARNING: Turning restriction was not reported removed at the estimated completion time.',
			'lc-reminder-open': 'Reminder to re-open lanes at completion time.',
			'r-reminder-place': 'Reminder to place turning restrictions at start time.',
			'lc-reminder-close': 'Reminder to close lanes at start time.',
			'r-reminder-remove': 'Reminder to remove turning restrictions at completion time.',
			'lcr-status-updated': 'Approval/Record Status Change',
			'lcr-contact-added': 'You were added to the request.',
			'lcr-contact-removed': 'You were removed from the request.',
			'lcr-updated': 'Lane closure request details were changed.',
			'r-not-placed': 'WARNING: Turning restriction not reported in-place at start time.',
			'contravention-new-message': 'New message for existing violation.',
			'lcr-new-message': 'New Messages',
			'contravention-updated': 'Violation was updated.',
			'lc-not-closed': 'WARNING: Lane closure not reported closed at the start time.',
			'lc-closed': 'Lanes reported as CLOSED.',
			'lc-opened': 'Lanes reported as OPENED.',
			'new-lcr': 'Confirmation that a new PENDING lane closure request was made.',
			'r-placed': 'Restrictions reported as IN PLACE.',
			'r-removed': 'Restrictions reported as REMOVED.',
			'lcr-approved': 'Request was APPROVED, you can begin work.',
			'lcr-denied': 'Request was DENIED.',
			'lcr-completed': 'Request was COMPLETED.',
			'lcr-cancelled': 'Request was CANCELLED.',
			'new-contravention': 'New Violations.',
			'lcr-change-request': 'When the requester asks for new changes to the lane closure request.',
		},
		'userSettingsDetails': {
			'lcr-new-message': "You will always receive an email notification for new messages.",
		},
		'userSettingsHelp': {
			'lcr-new-message': "",
			'lcr-denied': 'Sent to the requester and alternate requester.',
			'new-lcr': '',
			'lc-not-opened':'Sent to recipients by discretion of the City of Winnipeg.',
			'r-not-removed':'Sent to recipients by discretion of the City of Winnipeg.',
			'lc-reminder-open':'Sent to recipients by discretion of the City of Winnipeg.',
			'r-reminder-place':'Sent to recipients by discretion of the City of Winnipeg.',
			'lc-reminder-close':'Sent to recipients by discretion of the City of Winnipeg.',
			'r-reminder-remove':'Sent to recipients by discretion of the City of Winnipeg.',
			'lcr-status-updated':'',
			'lcr-contact-added':'',
			'lcr-contact-removed':'',
			'lcr-updated':"Changes to <strong>Approved</strong> requests are sent to everyone assigned.<br/>Changes to a <strong>Pending</strong> request are ONLY sent to the assigned requester, closure/restriction reporters, and City of Winnipeg approver.",
			'r-not-placed':'Sent to recipients by discretion of the City of Winnipeg.',
			'contravention-new-message':'',
			'contravention-updated':'',
			'lc-not-closed':'Sent to recipients by discretion of the City of Winnipeg.',
			'lc-closed':'Sent to everyone assigned.',
			'lc-opened':'Sent to everyone assigned.',
			'r-placed':'Sent to everyone assigned.',
			'r-removed':'Sent to everyone assigned.',
			'lcr-approved':'Sent to everyone assigned.',
			'lcr-completed': 'Sent to everyone assigned.',
			'lcr-cancelled':'Sent to everyone assigned.',
			'new-contravention':'',
			'lcr-change-request':'',
		},
		'userSettingsAllDetails': {
		},
		'userSettingsAllHelp': {
			'lcr-new-message': "",
			'lcr-denied': 'Sent to the requester and alternate requester.',
			'new-lcr': '',
			'lc-not-opened':'',
			'r-not-removed':'',
			'lc-reminder-open':'',
			'r-reminder-place':'',
			'lc-reminder-close':'',
			'r-reminder-remove':'',
			'lcr-status-updated':'',
			'lcr-contact-added':'',
			'lcr-contact-removed':'',
			'lcr-updated':"Only changes to <strong>Approved</strong> requests will be sent.",
			'r-not-placed':'',
			'contravention-new-message':'',
			'contravention-updated':'',
			'lc-not-closed':'',
			'lc-closed':'',
			'lc-opened':'',
			'r-placed':'',
			'r-removed':'',
			'lcr-approved':'',
			'lcr-completed': 'Sent to everyone assigned.',
			'lcr-cancelled':'',
			'new-contravention':'',
			'lcr-change-request':'',
		},


		'auditLog': {
			'laneClosureRequest': {
				'ActAsAca': 'Act as Authorized Construction Agency',
				'AcaDcz': 'Is ACA for DCZ',
				'AcaTurnRestrictions': 'Is ACA for Turn Restrictions',
				'AcaParkingRemoval': 'Is ACA for Parking Removal',
				'AcaFullDirectional': 'Is ACA for Full/Directional Closure',
				'AffectedStreet': 'Primary Street Affected',
				'AlternateUserId': 'Alternate Contact',
				'AltPhone': 'Alternate Phone',
				'ApprovalStatusId': 'Approval Status',
				'Attachment': 'Attachment',
				'ClosureReporterId': 'Lane Closure Reporter',
				'ClosureActiveStatusId': 'Reported Closure Active Status ID',
				'RestrictionActiveStatusId': 'Reported Restriction Active Status ID',
				'ModifiedDate': 'Modified Date',
				'Comments': 'Details',
				'CompleteTypeId': 'Completion Status',
				'CrossingPermitEquipment': 'Type of Equipment Used While Crossing the Area',
				'CrossingPermitLocation': 'Crossing the Sidewalk / Boulevard / Curb Area',
				'CrossingPermitRequired': 'Crossing Permit Required',
				'DisplayTime': 'Display Time',
				'DczHazards': 'Physical Hazards when Workers are not Present',
				'DczHoursOfWork': 'Typical Hours of Work',
				'DczLimits': 'Construction Limits Change as Work Progresses',
				'DczRequired': 'Designated Construction Zone (DCZ) Required',
				'DczTemporaryTcRemoved': 'Temporary Traffic Control Removed at End of Each Work Day',
				'Description': 'Description',
				'DirectionId': 'Direction(s) of Travel',
				'Domain': 'Domain',
				'Email': 'Email',
				'FileName': 'File Name',
				'FirstCrossStreet': 'First Cross Street',
				'FirstName': 'First Name',
				'FromDate': 'Requested Start Date',
				'FromTime': 'Requested Start Time',
				'InternalComments': 'Internal Comments',
				'IsApproved': 'Administrator Approval',
				'IsAway': 'User Away',
				'IsEmergency': 'Closure Emergency',
				'IsUnderTwoHours': 'Less Than 2 Hours',
				'LanesClosedSameTime': 'Total Number of Lanes Closed at Same Time',
				'LastCrossStreet': 'Last Cross Street',
				'LastName': 'Last Name',
				'lcrAltClosureReporter': 'Alternate Lane Closure Reporter(s)',
				'lcrAltRequester': 'Alternate Requester(s)',
				'lcrAltRestrictionReporter': 'Alternate Turning Restriction Reporter(s)',
				'lcrBicycle': 'Bicycle Lane / Pathway Closures',
				'lcrContact': 'Additional Contacts',
				'lcrLane': 'Lane Closures',
				'lcrParkingRemoval': 'Parking Removal Lanes',
				'lcrRestriction': 'Turning Restrictions',
				'lcrSidewalk': 'Sidewalk Closures',
				'lcrTrafficSignal': 'Altered Traffic Signals',
				'lcrTransit': 'Transit Affected',
				'Message': 'Message',
				'Name': 'Organization Name',
				'NatureOfWorkId': 'Primary Reason for Closure',
				'NewRequest': 'Submitted new request',
				'OfficerId': 'Enforcement Officer',
				'OrganizationActive': 'Organization Active',
				'OrganizationComments': 'Comments',
				'OrganizationId': 'Organization',
				'OrganizationTypeId': 'Type of Organization',
				'OwnerId': 'Approver',
				'OwnerProjectId': 'Approver Project',
				'PaidParkingAffected': 'Paid Parking Affected',
				'BidAdmin': 'City Administrator',
				'ParentId': 'Parent Organization / Group',
				'ParkingEndAddress': 'Parking Removal Ending Point',
				'ParkingLane': 'Parking Removal Lane',
				'ParkingRemovalId': 'Parking Removal',
				'ParkingRemovalMetres': 'Parking Removal Meters',
				'ParkingStartAddress': 'Parking Removal Starting Point',
				'PermitLiabilityInsurance': 'Liability Insurance',
				'PermitNearestStreetNumber': 'Nearest Street Number to Affected Closure Area',
				'PermitRequests': 'Additional Relevant Permit Information Provided',
				'PermitRequired': 'Permit Required',
				'PermitRoadwayFrom': 'Permit Affected Roadway Start',
				'PermitRoadwayMetres': 'Permit Affected Roadway Length',
				'PermitRoadwayTo': 'Permit Affected Roadway End',
				'PermitSidewalkFrom': 'Permit Affect Sidewalk From',
				'PermitSidewalkMetres': 'Permit Affected Sidewalk Length',
				'PermitSidewalkTo': 'Permit Affect Sidewalk To',
				'Phone': 'Phone',
				'PresetBlock': 'Closures and Restrictions',
				'ProjectBidNumber': 'Bid Opportunity Number',
				'Recipient': 'Recipient(s)',
				'RecordStatusId': 'Record Status',
				'RequesterComments': 'Comments and Explanations',
				'RequesterId': 'Requester',
				'RequesterProjectId': 'Requester\'s Project',
				'RestrictionReporterId': 'Turning Restriction Reporter',
				'SupervisorUserId': 'Supervisor',
				'Title': 'Title',
				'TempTrafficControl': 'Temporary Traffic Control by Traffic Services',
				'ToDate': 'Estimated Completion Date',
				'ToTime': 'Estimated Completion Time',
				'TransitAffected': 'Transit is Affected',
				'TrafficEffect': 'Traffic Effect',
				'TransitOther': 'Transit Affected Other',
				'TransitStopNumbers': 'Bus Stop Numbers',
				'TypeId': 'Violation Type',
				'UpdatedRequest': 'Updated request',
				'UserActive': 'Account Active',
				'Username': 'Username',
				'WfseoControlCode': 'Control Code / Name - City of Winnipeg Film and Special Events Office Identifier',
				'WfseoPermitRequestInfo': 'Permit Request - City of Winnipeg Film and Special Events Office Identifier',
				'WorkDoneForId': 'Work Done For',
				'WorkZoneKph': 'Work Zone Speed Limit (Kph)',
				'WorkZoneReduceKph': 'Work Zone Reduce Speed Limit',
				'NotificationSetting': 'Notification Setting',
			},
			'userSettings': {
				'lc-not-opened': 'Lane closure was re-opened at the estimated completion time',
				'r-not-removed': 'Turning restriction was not removed at the estimated completion time',
				'lc-reminder-open': 'Reminder to re-open lane closure at completion time',
				'r-reminder-place': 'Reminder to report restriction in-place at start time',
				'lc-reminder-close': 'Reminder to report closure in-effect at start time',
				'r-reminder-remove': 'Reminder to report turning restriction removed at completion time',
				'lcr-status-updated': 'Approval/Record Status Changed',
				'lcr-contact-added': 'You were added to the request.',
				'lcr-contact-removed': 'You were removed from the request.',
				'lcr-updated': 'Lane closure request details were changed by someone else.',
				'r-not-placed': 'Turning restriction was not in-place at start time',
				'contravention-new-message': 'New message for existing violation',
				'lcr-new-message': 'New message for lane closure request',
				'contravention-updated': 'Violation was updated',
				'lc-not-closed': 'Lane closure was not closed at the start time',
				'lc-closed': 'Lane closure was closed',
				'lc-opened': 'Lane closure was open',
				'new-lcr': 'New lane closure request',
				'r-placed': 'Restriction in-place',
				'r-removed': 'Restriction removed',
				'lcr-approved': 'Request was approved',
				'lcr-denied': 'Request was denied',
				'lcr-completed': 'Request was completed',
				'lcr-cancelled': 'Request was cancelled',
				'new-contravention': 'New Violation',
				'lcr-change-request': 'When the requester asks for new changes to the lane closure request.',
				'myRequest': 'My Requests',
				'organizationRequest': 'Organization Requests',
			},
		},
	},
	'fr-CA': {
		'title': 'Lane Closures',
		'locale': 'La langue',
		'switchToLocale': 'English',
		'header': {
			'appTitle': 'Fermetures de voies'
		},
		'views': {
			'login': {
				'title': '',
				'disclaimerTitle': 'ExonÃ©ration de responsabilitÃ© et indemnitÃ© :',
				'disclaimerBody': 'Les renseignements contenus sur ce site Web sont donnÃ©s Ã  titre de service public et ne peuvent Ãªtre utilisÃ©s quâ€™Ã  des fins dâ€™information. Bien que les renseignements fournis reprÃ©sentent les travaux projetÃ©s dans le cadre du programme dâ€™immobilisations de lâ€™annÃ©e en cours, la Ville de Winnipeg ne peut garantir quâ€™ils sont exacts et actuels en tout temps. Bien quâ€™il soit rare que les projets dÃ©passent les dÃ©lais impartis, la Ville ne peut garantir que le travail sera achevÃ© dans tous les cas.<br/><br/> Les renseignements contenus dans le prÃ©sent site Web peuvent changer sans prÃ©avis. Le site winnipeg.ca ET SES SOCIÃ‰TÃ‰S AFFILIÃ‰ES NE SONT EN AUCUNE MANIÃˆRE RESPONSABLES EN CAS DE DOMMAGES DIRECTS, INDIRECTS, SPÃ‰CIAUX OU CONSÃ‰QUENTS RÃ‰SULTANT DE Lâ€™UTILISATION OU DE LA MAUVAISE UTILISATION OU INTERPRÃ‰TATION DU CONTENU, DES PRODUITS ET DES SERVICES OFFERTS PAR CE SITE WEB.<br/><br/> Le fait pour vous dâ€™utiliser ce site signifie que vous acceptez dâ€™indemniser, de dÃ©fendre et de dÃ©gager de toute responsabilitÃ© la Ville de Winnipeg, ses agents, ses employÃ©s et ses reprÃ©sentants autorisÃ©s, en cas de perte, de blessure (y compris les blessures entraÃ®nant la mort), de demande, dâ€™action, de coÃ»ts, de dÃ©pense ou de rÃ©clamation de toute sorte, incluant notamment des frais dâ€™avocat, relativement Ã  lâ€™usage quelconque que vous faites du contenu ou des services offerts par ce site Web.',
				'alreadyLoggedIn': 'You are already logged in.'
			}
		}
	}
};